import { FC } from 'react';

interface Props {
    onClick?: () => void;
}

const SearchIcon: FC<Props> = ({ onClick }) => {
    return (
        <svg
            className="icon-search icon br-icon-search"
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            onClick={onClick}
        >
            <path
                className="-path"
                d="M11.9999 18.5454C16.2173 18.5454 19.6363 15.1265 19.6363 10.9091C19.6363 6.69162 16.2173 3.27271 11.9999 3.27271C7.78244 3.27271 4.36353 6.69162 4.36353 10.9091C4.36353 15.1265 7.78244 18.5454 11.9999 18.5454Z"
                stroke="currentColor"
                stroke-width="2"
            ></path>
            <path className="-path" d="M17.4546 16.3636L20.7273 19.6364L17.4546 16.3636Z" fill="currentColor"></path>
            <path
                className="-path"
                d="M17.4546 16.3636L20.7273 19.6364"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            ></path>
        </svg>
    );
};

export default SearchIcon;
